import uuid from 'uuid';
import lodash from 'lodash';

import {
    DetailSelect,
    DetailDatePicker,
    DetailRadioList,
    DetailInput,
} from './EventDetailsControls';

export const MONITOR_VISIT_TYPES = [{
    value: 'Remote Monitoring Visit',
    label: 'Remote Monitoring Visit',
}, {
    value: 'Remote Source Data Verification Visit',
    label: 'Remote Source Data Verification Visit',
}, {
    value: 'Site Initiation Visit',
    label: 'Site Initiation Visit',
}, {
    value: 'Site Monitoring Visit',
    label: 'Site Monitoring Visit',
}, {
    value: 'Site Qualification Visit',
    label: 'Site Qualification Visit',
}, {
    value: 'Study Close Out Visit',
    label: 'Study Close Out Visit',
}];

export const MonitorVisitFields = ({updateFieldValue, details, monitors=[]}) => {
    const formattedMonitors = monitors.map(formatItemBy('id', 'displayName'));
    const sortedMonitors = lodash.sortBy(formattedMonitors, ['label']);
    return [
        <DetailSelect key={uuid.v4()}
            label="Type of Monitor Visit"
            placeholder="Select type of Monitor Visit"
            onSelect={value => updateFieldValue('monitorVisitType', value)}
            value={details.monitorVisitType}
            items={MONITOR_VISIT_TYPES} />,
        <DetailDatePicker key={uuid.v4()}
            label="Date of Monitor Visit"
            value={details.dateOfVisit}
            onSelect={value => updateFieldValue('dateOfVisit', value)} />,
        <DetailSelect key={uuid.v4()}
            label="Monitor"
            placeholder="Select Monitor"
            onSelect={value => updateFieldValue('monitorId', value)}
            value={details.monitorId}
            items={sortedMonitors} />,
    ];
};

export const ICFChangeFields = ({ updateFieldValue, details, icfLanguages }) => {
    const icfTypeOptions = [
        'Addendum',
        'Biological Samples',
        'HIPAA',
        'Main',
        'Pharmacogenomics',
        'Pregnant Partner/Subject',
        'Pre-Screen'
    ];
    const reconsentRequiredOptions = [
        'Yes, re-consent all active subjects',
        'No, re-consent not necessary',
    ];

    return [
        <DetailDatePicker
            key={'irb-approval-date-picker'}
            label='IRB Approval Date'
            value={details.irbApprovalDate}
            onSelect={value => updateFieldValue('irbApprovalDate', value)}
        />,
        <DetailRadioList
            key={'icf-type-radio'}
            name={'icf-type-radio'}
            title={'ICF Type'}
            options={icfTypeOptions}
            value={details.icfType}
            onSelect={(selection) => updateFieldValue('icfType', selection)}
        />,
        <DetailSelect
            key={'icf-language-select'}
            label='ICF Language'
            placeholder='Select ICF Language'
            onSelect={value => updateFieldValue('icfLanguage', value)}
            value={details.icfLanguage}
            items={icfLanguages}
        />,
        <DetailRadioList
            key={'reconsent-required-radio'}
            name={'reconsent-required-radio'}
            title={'Reconsent Required?'}
            options={reconsentRequiredOptions}
            value={details.reconsentRequired}
            onSelect={(selection) => updateFieldValue('reconsentRequired', selection)}
        />,
        <DetailInput
            key={'icf-sponsor-version-input'}
            title={'Sponsor Version'}
            placeholder={'1.0'}
            value={details.sponsorVersion}
            onChange={(e) => updateFieldValue('sponsorVersion', e.target.value)}
        />,
        <DetailInput
            key={'icf-site-version-input'}
            title={'Site Version'}
            placeholder={'1.0'}
            value={details.siteVersion}
            onChange={(e) => updateFieldValue('siteVersion', e.target.value)}
        />,
        <DetailInput
            key={'icf-protocol-version-input'}
            title={'Protocol Version'}
            placeholder={'1.0'}
            value={details.protocolVersion}
            onChange={(e) => updateFieldValue('protocolVersion', e.target.value)}
        />,
        <DetailInput
            key={'icf-summary-of-changes-input'}
            title={'Summary of Changes'}
            placeholder={'What changed?'}
            value={details.summaryOfChanges}
            onChange={(e) => updateFieldValue('summaryOfChanges', e.target.value)}
        />,
    ];
};

export function formatItemBy(valueField='', labelField=''){
    return function(obj={}) {
        return {
            value: obj[valueField],
            label: obj[labelField],
        };
    };
}


export const EventTypeFieldsMap = {
    'monitorVisit': MonitorVisitFields,
    'icfVersionChange': ICFChangeFields,
};
